import { useState } from 'react'

export default function FieldGroup({ children, active, name }) {
  const [isFocused, setIsFocused] = useState(false)
  const isActive = isFocused || !!active
  return (
    <div
      className={`field-group${isActive ? ' is-active' : ''}`}
      data-field={name || undefined}
      onFocus={() => setIsFocused(true)}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) setIsFocused(false)
      }}
    >
      {children}
    </div>
  )
}
